<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text class="pt-3">
          <v-btn elevation="6" outlined small>n</v-btn> افزودن مشتری جدید
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <loading v-if="vLoading" />

    <v-card>
      <v-card-title>
        <h4>ثبت فاکتور خرید جدید</h4>
      </v-card-title>
      <v-card-text class="py-0 px-2">
        <v-container class="mt-3">
          <!-- <v-select
            label="نوع فاکتور"
            :items="invoiceTypes"
            v-model="newInvoice.type"
            outlined
            dense
          />
          <v-row>
            <v-col cols="9">
              <v-autocomplete
                @change="getBalance(newInvoice.shopCustomerId)"
                auto-select-first
                no-data-text="نتیجه‌ای یافت نشد!"
                v-model="newInvoice.shopCustomerId"
                :items="customers"
                item-text="name"
                item-value="id"
                class="p-0"
                label="نام مشتری"
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col class="text-right" cols="3">
              <v-btn
                color="primary"
                style="float: right"
                @click="openAddCustomer()"
                v-shortkey.once="['n']"
                @shortkey="openAddCustomer()"
              >
                ثبت جدید +
              </v-btn></v-col
            >
          </v-row>

          <p v-if="newInvoice.shopCustomerId">
            مانده حساب مشتری:
            <span v-if="newInvoice.customerBalance">{{
              newInvoice.customerBalance
            }}</span>
            <b-spinner v-else></b-spinner>
          </p>
          <hr /> -->
          <b-input-group class="my-2">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="جستجو"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
                variant="danger"
                >حذف</b-button
              >
            </b-input-group-append>
          </b-input-group>
          <b-table
            responsive
            show-empty
            id="productsTable"
            :items="products"
            :fields="fields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :current-page="currentPage"
            :per-page="perPage"
            :busy="isBusy"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>

            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <b-button
                  class="mx-2"
                  variant="success"
                  @click="addItem(data.item, 1)"
                  >+1
                </b-button>
                <b-button
                  class="mx-2"
                  variant="success"
                  @click="addItem(data.item, 10)"
                  >+10
                </b-button>
                <b-button
                  class="mx-2"
                  variant="success"
                  @click="addItem(data.item, 100)"
                  >+100
                </b-button>
                <b-button
                  class="mx-2"
                  variant="success"
                  @click="addItem(data.item, 1000)"
                  >+1000
                </b-button>
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (currentPage - 1) }}
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="productsTable"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>

          <hr />

          <b-table
            :busy="isBusy2"
            responsive
            show-empty
            id="productsTable"
            :items="selectedProducts"
            :fields="selectedFields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(price)="data">
              <div style="text-align: center; vertical-align: middle">
                <v-row>
                  <v-col class="text-center pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      class="w-50 mx-auto"
                      v-model="data.item.price"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <p class="grey--text text--darken-2 mb-0">
                  {{ Number(data.item.price).toLocaleString() }}
                  ریال
                </p>
              </div>
            </template>
            <template v-slot:cell(amount)="data">
              <b-button
                class="mx-2"
                variant="success"
                @click="addItem(data.item, 1)"
                >+1
              </b-button>
              <b-button
                class="mx-2"
                variant="success"
                @click="addItem(data.item, 10)"
                >+10
              </b-button>
              <b-button
                class="mx-2"
                variant="success"
                @click="addItem(data.item, 100)"
                >+100
              </b-button>
              <strong>{{ data.value }}</strong>
              <b-button
                class="mx-2"
                variant="danger"
                @click="reduceItem(data.item, data.index, 1)"
                >-1
              </b-button>
              <b-button
                class="mx-2"
                variant="danger"
                @click="reduceItem(data.item, data.index, 10)"
                :disabled="data.value < 11"
                >-10
              </b-button>
              <b-button
                class="mx-2"
                variant="danger"
                @click="reduceItem(data.item, data.index, 100)"
                :disabled="data.value < 101"
                >-100
              </b-button>
              <b-button
                class="mx-2"
                variant="danger"
                @click="removeItem(data.index)"
                ><i class="fa fa-trash text-light"></i>
              </b-button>
            </template>
            <template v-slot:cell(totalPrice)="data">
              <div style="text-align: center; vertical-align: middle">
                {{
                  Number(
                    Number(data.item.amount) * data.item.price
                  ).toLocaleString()
                }}
                ریال
              </div>
            </template>

            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <br />
          <div>
            <h5>
              جمع کل:
              {{
                this.selectedProducts
                  .map((x) => Number(x.price) * Number(x.amount))
                  .reduce((a, b) => a + b, 0)
                  .toLocaleString() + " ریال"
              }}
            </h5>
          </div>
          <br />

          <v-textarea
            outlined
            dense
            label="توضیحات"
            rows="5"
            v-model="description"
          ></v-textarea>
          <br />
        </v-container>
      </v-card-text>
      <v-card-actions class="p-3 mr-3">
        <v-btn
          :disabled="!this.selectedProducts.length"
          color="primary"
          @click="addInvoice()"
        >
          ثبت
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="newCustomerDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ثبت مشتری جدید</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="نام مشتری"
              :loading="isBusy2"
              v-model="newCustomer.name"
            ></v-text-field>
            <v-select
              label="نوع مشتری"
              :items="customerTypes"
              v-model="newCustomer.type"
              :loading="isBusy2"
              outlined
              dense
            />
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="newCustomerDialog = false"
          >
            لغو
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!newCustomer.name"
            :loading="isBusy2"
            @click="addCustomer()"
          >
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- receipt -->

    <v-card v-if="recLoaded">
      <div id="Receipt" v-show="false">
        <table class="mainTable m-3 p-4 h-100 w-100">
          <thead>
            <tr>
              <td>
                <div style="text-align: center; width: 100%">
                  <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content" style="padding: 5px 15px">
                  <div
                    style="
                      border: 1px solid black;
                      border-radius: 10px;
                      padding: 0 10px;
                      min-height: 90px;
                      margin-bottom: 10px;
                    "
                  >
                    <div style="direction: rtl">
                      <div style="text-align: center">
                        <span style="font-size: 19px">فاکتور خرید</span>
                      </div>
                      تاریخ: {{ moment(new Date()).format("jYYYY/jMM/jDD") }}
                      <br />
                      ساعت: {{ moment(new Date()).format("HH:mm") }}
                    </div>
                  </div>
                  <b-table
                    bordered
                    :fields="selectedFields"
                    :items="selectedProducts"
                    small="small"
                    responsive
                  >
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell(name)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(amount)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(price)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }} ریال
                      </div>
                    </template>
                    <template v-slot:cell(totalPrice)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{
                          (
                            Number(data.item.amount) * data.item.price
                          ).toLocaleString()
                        }}
                        ریال
                      </div>
                    </template>
                  </b-table>
                  <br />
                  <div>
                    <span style="float: right">
                      {{
                        "مبلغ کل: " +
                        selectedProducts
                          .map((x) => Number(x.price) * Number(x.amount))
                          .reduce((a, b) => a + b, 0)
                          .toLocaleString() +
                        " ریال"
                      }}
                    </span>
                  </div>
                  <br />
                  <br />
                  <div
                    style="
                      border: 1px solid grey;
                      border-radius: 10px;
                      min-height: 80px;
                      padding: 10px;
                    "
                  >
                    <span>توضیحات: {{ description }}</span>
                  </div>
                  <br />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-card>

    <!-- receipt -->
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import router from "../../router";
import moment from "moment-jalaali";

export default {
  components: {},
  data: function () {
    return {
      moment: moment,
      guide: false,
      recLoaded: false,

      isBusy: true,
      isBusy2: false,
      newInvoice: {
        totalPrice: 0,
        customerBalance: "",
        shopCustomerId: null,
      },
      totalRows: "",
      invoiceTypes: [
        { value: "definite", text: "قطعی - پرداخت در لحظه" },
        { value: "respite", text: "امانی - پرداخت اعتباری" },
        { value: "preInvoice", text: "پیش فاکتور" },
      ],
      customers: [],
      products: [],
      selectedProducts: [],
      fields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        // { key: "price", label: "قیمت" },
        { key: "sum", label: "موجودی" },
        { key: "operation", label: "افزودن" },
      ],
      customerTypes: [
        { value: "naturalPerson", text: "حقیقی" },
        { value: "legalPerson", text: "حقوقی" },
      ],
      selectedFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل" },
        // { key: "sum", label: "موجودی" },
        // { key: "operation", label: "عملیات" },
      ],
      filter: null,
      currentPage: 1,
      perPage: 10,
      amountOptions: {
        decimal: ".",
        thousands: ",",
        precision: 0,
      },
      tempCustomer: "",
      valueWhenIsEmpty: "0",
      receiptNumber: "",
      newCustomerDialog: false,
      newCustomer: {},
      toman: "",
      description: "",
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    openAddCustomer() {
      this.newCustomer = {};
      this.newCustomerDialog = true;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    addCustomer() {
      this.isBusy2 = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/new",
        {
          name: this.newCustomer.name,
          type: this.newCustomer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy2 = false;
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.newCustomer = {};
            this.newCustomerDialog = false;
            this.getCustomers();
            this.tempCustomer = res.data.id;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.isBusy2 = false;
        });
    },
    getBalance(customerId) {
      this.newInvoice.customerBalance = "";
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/customerBalance",
        {
          shopCustomerId: customerId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.newInvoice.customerBalance = Number(
              res.data.balance.split(",").join("")
            );
            if (this.newInvoice.customerBalance > 0) {
              this.newInvoice.customerBalance =
                this.newInvoice.customerBalance.toLocaleString() +
                " ریال بدهکار";
            } else if (this.newInvoice.customerBalance < 0) {
              this.newInvoice.customerBalance =
                Math.abs(this.newInvoice.customerBalance).toLocaleString() +
                " ریال بستانکار";
            } else {
              this.newInvoice.customerBalance = "تسویه";
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    addItem(item, amount) {
      this.isBusy2 = true;
      let myIndex = this.selectedProducts.findIndex(
        (product) => product.id == item.id
      );
      if (myIndex == -1) {
        let thisItem = item;
        thisItem.price = 0;
        thisItem.amount = Number(amount);
        this.selectedProducts.push(thisItem);
      } else {
        this.selectedProducts[myIndex].amount =
          Number(this.selectedProducts[myIndex].amount) + Number(amount);
      }
      this.isBusy2 = false;
    },
    reduceItem(item, index, amount) {
      this.isBusy2 = true;
      let myamount = item.amount;
      if (myamount <= amount) {
        this.selectedProducts.splice(index, 1);
      } else {
        this.selectedProducts[index].amount =
          Number(this.selectedProducts[index].amount) - Number(amount);
      }
      this.isBusy2 = false;
    },
    removeItem(index) {
      this.selectedProducts.splice(index, 1);
    },
    addInvoice() {
      let myPrices = this.selectedProducts.map((x) => x.price);
      myPrices = myPrices.filter((x) => !x).length;
      if (myPrices) {
        this.toast("وارد کردن مبلغ برای تمامی اقلام الزامی است", "error");
      } else {
        this.vLoading = true;
        let itemIds = this.selectedProducts.map((x) => x.id);
        let totalCost = this.selectedProducts
          .map((x) => Number(x.price) * Number(x.amount))
          .reduce((a, b) => a + b, 0);
        Axios.post(
          this.baseUrl + "/ppkpms/shop/purchases/new",
          {
            // shopCustomerId: this.newInvoice.shopCustomerId,
            // type: this.newInvoice.type,
            totalCost: totalCost,
            itemIds: itemIds,
            details: this.selectedProducts,
            description: this.description,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 201) {
              this.receiptNumber = res.data;
              this.recLoaded = true;
              this.toast("فاکتور با موفقیت ثبت شد", "success");
              this.vLoading = false;
            } else {
              const title = (
                <div>
                  <h5>خطا </h5>
                  <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                </div>
              );
              this.toast(title, "error");
              this.vLoading = false;
            }
          })
          .then(() => {
            this.printReceipt();
          })
          .then(() => {
            this.newInvoice = {
              totalPrice: 0,
              customerBalance: "",
              shopCustomerId: null,
            };
            this.description = "";
            this.shopCustomerId = "";
            this.selectedProducts = [];
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
            this.loading = false;
            this.recLoaded = false;
            this.vLoading = false;
          });
      }
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "Receipt", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("Receipt").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
      this.recLoaded = false;
    },
    getCustomers() {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.customers = res.data;
            if (this.tempCustomer) {
              this.newInvoice.shopCustomerId = this.tempCustomer;
              this.getBalance(this.tempCustomer);
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    getProducts() {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/goods/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.products = res.data;
            this.totalRows = this.products.length;
            this.isBusy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },

  mounted() {
    this.getCustomers();
    this.getProducts();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
thead {
  background-color: white;
  color: black;
}

@media print {
  td {
    font-family: "iransans" !important;
  }
  @page {
    size: A5 landscape;
    font-size: 30%;
    text-color: black;
  }

  table.mainTable {
    border: 0px !important;
  }
}
</style>
